import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";

export const PersonalityIntroduction = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setProgress(53))
    }, []);

    return (
        <>
            <ProgressLine />
            <main className="pt-28 w-[85%] m-auto min-h-dvh">
                <section className="flex flex-col">
                    <div className="video-container">
                        <ReactPlayer
                            url="https://www.dropbox.com/scl/fi/spp6tonptltckp46kx2oz/19-Personality-and-Charisma.mp4?rlkey=r30z49ua6xlo0m3u0zzcd8tgw&raw=1"
                            playing
                            controls
                            className='react-player'
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div className="flex items-center gap-5 mt-8">
                        {/* <Link to={"/flow/vision/statement"}> */}
                        <Link to={"/flow/vision"}>
                            <span className="outlined-cta">
                                Back
                            </span>
                        </Link>
                        <Link to={"/flow/personality/values"}>
                            <span className="yellow-cta">
                                Next
                            </span>
                        </Link>
                    </div>
                </section>
                <HeaderSidebar activeEl="Personality & Charisma" />
            </main>
        </>
    )
}